import BoldText from '@/components/BoldText';
import HolidayBanner from '@/components/HolidayBanner';
import Layout from '@/components/layout';
import RegularText from '@/components/RegularText';
import { Ga4Event } from '@/constants/enum';
import { useGa4 } from '@/hooks/useGa4';
import { apiCaller } from '@/redux/query';
import { gaFourSelector } from '@/redux/slice/session.slice';
import { Button, Card, Icon, InlineGrid, Text } from '@shopify/polaris';
import { BookIcon, ChatIcon, GlobeAsiaFilledIcon } from '@shopify/polaris-icons';
import { useEffect, useMemo, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Overview from './Overview';
import { DashboardStyled } from './styled';
import ThingsToDoNext from './thingsToDoNext';

const Dashboard = () => {
  const twitterRef = useRef(null);
  const { handleGa4 } = useGa4();
  const { t } = useTranslation(['dashboard', 'common']);
  const gaFour = useSelector(gaFourSelector);
  const fetchDataSettings = apiCaller.useGetGeneralDetailQuery();

  const infoAndSupport = useMemo(() => {
    return [
      {
        title: t('contact_support'),
        description: (
          <span>
            <Trans t={t} i18nKey={'we_provide_support'}>
              We provide <b>24/7</b> support, feel free to contact us if you get any problems with the app.
            </Trans>
          </span>
        ),
        onAction: () => {
          const sendText = 'I need assistance with using Age Verify';
          try {
            $crisp.push(['set', 'session:event', ['ReviewStoreAgeVerification']]);
            $crisp.push(['do', 'chat:open']);
            $crisp.push(['do', 'message:send', ['text', sendText]]);
          } catch (err) {
            console.log(err);
          }
        },
        btnContent: t('chat_with_us'),
        icon: ChatIcon,
      },
      {
        title: t('read_user_guideline'),
        description: t('step_by_step_instruction_articles'),
        onAction: () => {
          window.open('https://help.omegatheme.com/en/category/blockify-age-verification-18-10ycadj/');
        },
        btnContent: t('read_user_guideline'),
        icon: BookIcon,
      },
      {
        title: t('discover_use_cases'),
        description: t('explore_helpful_articles_rule_use_cases_verifying_age'),
        onAction: () => {
          window.open('https://help.omegatheme.com/en/article/settings-1rdo11p/');
        },
        btnContent: t('view_use_cases'),
        icon: GlobeAsiaFilledIcon,
      },
    ];
  }, [t]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          handleGa4(Ga4Event.ImpressTwitter);
        }
      });
    });

    if (twitterRef.current) {
      observer.observe(twitterRef.current);
    }

    // Cleanup observer khi component unmount
    return () => {
      if (twitterRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(twitterRef.current);
      }
    };
  }, [gaFour, handleGa4, twitterRef]);

  return (
    <>
      <Layout isBigHeader title={t('hello_name', { name: fetchDataSettings.data?.data?.nameShop ?? 'store' }) + ','}>
        <DashboardStyled>
          <div className="fz-18">
            <Text variant="bodyLg" as="span">
              {t('welcome_age_verification_popup', { name: 'Age Verification Pop-up' })} 🎉
            </Text>
          </div>

          <div className="mt-8">
            <HolidayBanner />
          </div>

          <ThingsToDoNext
            hasCustomize={fetchDataSettings.data?.data.customizedSettings || false}
            hasTestApp={fetchDataSettings.data?.data.completedSetup || false}
            siteUrl={fetchDataSettings.data?.data.siteUrl || ''}
            shop={fetchDataSettings.data?.data.shop || ''}
            isLoadingFetchDataSettings={fetchDataSettings.isLoading}
          />

          <div className="mt-16">
            <Overview />
          </div>
          <div className="card-info">
            <InlineGrid columns={{ xl: 3, lg: 3, md: 3, sm: 1, xs: 1 }} gap={'400'}>
              {infoAndSupport.map((item, index) => {
                return (
                  <Card key={index}>
                    <div className="card-container">
                      <div>
                        <div className="d-flex">
                          <Icon source={item.icon} />
                          <div className="ml-8">
                            <BoldText>{item.title}</BoldText>
                          </div>
                        </div>
                        <div className="card-text">
                          <RegularText>{item.description}</RegularText>
                        </div>
                      </div>
                      <div>
                        <Button onClick={item.onAction}>{item.btnContent}</Button>
                      </div>
                    </div>
                  </Card>
                );
              })}
            </InlineGrid>
          </div>

          {/* <div className="mt-16">
            <FAQ></FAQ>
          </div> */}

          {/* <div className="mt-16" ref={twitterRef}>
            <BannerTemplate src={images.twitter}>
              <BoldText>{t('bad_track')}</BoldText>
              <div className="mt-8">
                <RegularText>
                  <b>{t('capi_and_analytics')}.</b> {t('no_more_losss_data')}
                </RegularText>
              </div>
              <div className="mt-16">
                <Button
                  url="https://apps.shopify.com/twitter-multi-pixels?utm_campaign=crs&utm_source=age&utm_medium=homeinapp"
                  target="_blank"
                  variant="primary"
                  onClick={() => {
                    handleGa4(Ga4Event.ClickTwitter);
                  }}
                >
                  {t('set_up_now')}
                </Button>
              </div>
            </BannerTemplate>
          </div> */}

          {/* <div className="app-recommended" ref={recommendAppRef}>
            <RecommenedApps />
          </div> */}
        </DashboardStyled>
      </Layout>
    </>
  );
};
export default Dashboard;
